(() => {
  const initialise = (scope = document) => {
    scope.querySelectorAll('.what-we-do__layers').forEach((container) => {
      if (container.dataset.stickyLayersInitialised === 'true') return;

      const layers = [...container.querySelectorAll('.what-we-do__layer')];
      if (!layers.length) return;

      let measureFrame = null;
      const measuredHeights = new WeakMap();

      const measure = () => {
        if (measureFrame !== null) return;

        measureFrame = window.requestAnimationFrame(() => {
          measureFrame = null;

          layers.forEach((layer) => {
            const height = layer.offsetHeight;
            if (measuredHeights.get(layer) === height) return;

            measuredHeights.set(layer, height);
            layer.style.setProperty('--layer-height', `${height}px`);
          });
        });
      };

      const observer = new ResizeObserver(measure);
      layers.forEach((layer) => observer.observe(layer));

      container.querySelectorAll('.what-we-do-wrapper').forEach((wrapper) => {
        const hotspot = wrapper.querySelector('.what-we-do__product-hotspot');
        if (!hotspot) return;

        const toggleCard = () => {
          const isOpen = wrapper.classList.toggle('is-open');
          hotspot.setAttribute('aria-expanded', String(isOpen));
        };

        hotspot.addEventListener('click', toggleCard);
        hotspot.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          toggleCard();
        });
      });

      measure();

      container.dataset.stickyLayersInitialised = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise());
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
